import { useIntlayerLocaleAdapter } from '../adapters/intlayer-locale'
import { makeSetLocaleUseCase } from '../application/set-locale'

const useLocale = () => {
	const adapter = useIntlayerLocaleAdapter()
	const setLocale = makeSetLocaleUseCase(adapter)
	const locale = adapter.get()

	return { locale, setLocale }
}

export { useLocale }
